import { KeyRound } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  // Lista duplicada para el bucle continuo: la clave combina copia + texto
  const items = [0, 1].flatMap((copy) => t.marquee.map((item) => ({ key: `${copy}-${item}`, item })));

  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden bg-gradient-to-r from-orange-600 via-orange-500 to-orange-600 py-3.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.25),inset_0_-1px_0_rgba(0,0,0,0.25),0_20px_40px_-20px_rgba(249,115,22,0.6)]"
    >
      <div className="animate-marquee flex w-max items-center gap-8 pr-8">
        {items.map(({ key, item }) => (
          <span key={key} className="flex items-center gap-8 whitespace-nowrap">
            <span className="font-mono text-xs sm:text-sm font-semibold tracking-[0.2em] text-white uppercase">
              {item}
            </span>
            <KeyRound className="h-3.5 w-3.5 text-white/80" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
